import { RootState } from '../index';
import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { selectUserEmail } from '../userData/selectors';

const newUsers = (state: RootState) => state.usersDetails.usersDetails;

const selectAdminUsers = createDraftSafeSelector(
  newUsers,
  (usersDetails) => usersDetails || [],
);

const selectCurrentUser = createDraftSafeSelector(
  selectAdminUsers,
  selectUserEmail,
  (users, currentUserEmail) =>
    users.find((u) => u.email === currentUserEmail) || null,
);

const selectResponsibleOptionsList = createDraftSafeSelector(
  [newUsers],
  (users) => {
    const userSet = new Set();
    return users.map(({ name, email, countries }) => {
      userSet.add(email);
      return { name, email, countries };
    });
  },
);

export {
  selectAdminUsers,
  newUsers,
  selectResponsibleOptionsList,
  selectCurrentUser,
};
